import { render, staticRenderFns } from "./CityWater.vue?vue&type=template&id=14aa8a9d&"
import script from "./CityWater.vue?vue&type=script&lang=js&"
export * from "./CityWater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports